<template>
  <div class="analysisOverview">
    <h6>{{ overviewData.title }}</h6>
    <h5>
      {{ overviewData.num }}
      <span v-if="overviewData.unit">{{ overviewData.unit }}</span>
    </h5>

    <div class="listBox">
      <div
        class="row"
        v-if="overviewData.yoy && overviewData.yoy != 'undefined'"
      >
        <p>同比</p>
        <h6>{{ overviewData.yoy }}</h6>
      </div>
      <div
        class="row"
        v-if="overviewData.mom && overviewData.mom != 'undefined'"
      >
        <p>环比</p>
        <h6>{{ overviewData.mom }}</h6>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["overviewData"],
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>

<style lang="scss" scoped>
.analysisOverview {
  width: 100%;
  height: 100%;
  @include setFlexColumn;
  justify-content: center;
  h6 {
    font-size: 18px;
  }
  h5 {
    font-size: 30px;
    color: #28cccb;
    margin: 10px 0;
    span {
      font-size: 14px;
      font-weight: normal;
      color: #999;
    }
  }
  .listBox {
    @include setFlexStart;
    .row {
      width: 50%;
      @include setFlexStart;
      p {
        color: #666666;
        margin-right: 20px;
      }
    }
  }
}
</style>
